/* tslint:disable:variable-name */
import { Component, HostListener, OnInit } from '@angular/core';
import { BreakDialog } from '../dialogs/break/break.dialog';
import { StorageService } from '../../service/storage.service';
import { TbwService } from '../../service/tbw.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { InstructionsDialog } from '../dialogs/instructions/instructions.dialog';
import { TranslateService } from '@ngx-translate/core';
import { FeedbackCountDialog } from '../dialogs/feedbackCount/feedbackCount.dialog';
import { TaskService } from 'src/app/service/tasks.service';



import utils from 'src/app/utils/utils'


@Component({
    selector: 'app-flash-beep',
    templateUrl: './flash-beep.component.html',
    styleUrls: ['./flash-beep.component.css']
})
export class FlashBeepComponent implements OnInit {

    private ctx: AudioContext;

    round = 0;
    demo = true;

    correct = 0;
    incorrect = 0;
    displayCorrect: number

    currentTrial = new Trial();

    flashSize = 400;
    delayBetweenRounds = 750;
    flashTime = 50;
    audio;

    started = false;
    waitingResponse = false;
    isFullScreen: boolean;
    startaf = false;
    demoFinished = false
    testFinished = false

    trials = []
    demoTrials = []
    loadingPage = true
    valid: boolean
    loadingTrials = true
    loadingDemo = true

    audioSource: string //can be speakers or headphones
    demoDone: boolean

    //for feedback percentage
    numTrials = 0

    //translations
    msg1: string

    roundFinished = true


    constructor(
        private router: Router,
        private snackBar: MatSnackBar,
        private dialog: MatDialog,
        private storage: StorageService,
        private tbwService: TbwService,
        public translate: TranslateService,
        private taskService: TaskService) {
        this.getTranslatedStrings()
    }

    getTranslatedStrings() {
        this.translate.get(['FB_P11'])
            .subscribe(translations => {
                this.msg1 = translations['FB_P11']
            })
    }

    ngOnInit() {
        AudioContext = (window as any).AudioContext || (window as any).webkitAudioContext;
        this.ctx = new AudioContext();

        this.audio = new Audio();
        // this.audio.src = '../assets/flashBeep.wav';
        this.audio.src = '../assets/20ms_beep.wav';
        // this.audio.src = "https://happyagain.essex.ac.uk/assets/loudnessPerception.wav"
        this.audio.load();
        document.addEventListener("fullscreenchange", function () {
            document.addEventListener("fullscreenchange", function () { })

        });
        this.flashSize = this.storage.getCircleWidth();
        this.tbwService.check_exp()
            .then(data => {
                this.valid = data.body.valid
                this.loadingPage = false
                if (this.valid) {
                    this.tbwService.getTest('live')
                        .then((test) => {
                            this.trials = test.body
                            // console.log(this.trials)
                            this.loadingTrials = false
                            this.tbwService.setDemo({ noReset: true })
                                .then(() => {
                                    this.tbwService.check_demo()
                                        .then((resp) => {
                                            //console.log(resp.body)
                                            this.demoDone = resp.body.done
                                            //console.log('BODY: ' + resp.body)
                                            //console.log('DEMODONE: ' + this.demoDone)
                                            if (!this.demoDone)
                                                this.tbwService.getTest('demo')
                                                    .then(demoTest => {
                                                        this.demoTrials = demoTest.body
                                                        this.loadingDemo = false

                                                    })
                                            else {

                                                this.demo = false
                                            }
                                        })
                                })
                        })
                }
            })


    }


    public get fullScreen(): boolean {
        //console.log("holaaa")
        if (!window.screenTop && !window.screenY) {
            alert('Browser is in fullscreen');
            return true
        }
        return false
    }

    setAudioType(type: string) {
        this.audioSource = type
    }

    start() {
        this.started = true;
        this.openFullScreen()

    }

    blink(beepFirst: boolean) {

        //console.log("va a hacer blink")
        //console.log("blink")
        // return new Promise((resolve, reject) => {
        //      const target = document.getElementById('blink-div');
        //      this.currentTrial.flashTimeStamp = this.timestamp();

        //      //allow response collection
        //      if (beepFirst){
        //         console.log("flash first");
        //          // console.log("flash first");
        //          this.waitingResponse = true;
        //      }


        //      target.style.display = (target.style.display === 'none' ? '' : 'none');
        //      setTimeout(() => {
        //          target.style.display = (target.style.display === 'none' ? '' : 'none');
        //          resolve('')
        //      }, this.flashTime);
        //  })

        const target = document.getElementById('blink-div');
        this.currentTrial.flashTimeStamp = this.timestamp();

        //allow response collection
        if (beepFirst) {
            console.log("flash first");
            this.waitingResponse = true;
        }


        target.style.display = (target.style.display === 'none' ? '' : 'none');
        setTimeout(() => {
            target.style.display = (target.style.display === 'none' ? '' : 'none');

        }, this.flashTime);
    }

    sound(soundFirst: boolean) {

        //allow response collection
        if (soundFirst) {
            console.log("sound first");
            this.waitingResponse = true;
        }
        this.currentTrial.beepTimeStamp = this.timestamp();

        utils.playCustomBeep(this.ctx);

        // this.audio.play();
    }

    async nextRound() {        //wait until previous round has finished
        while (!this.roundFinished)
            await this.wait(50)

        if (!this.demo && this.round !== 0 && ((this.trials[this.round].trialNum) % 40 === 0)
            && ((this.trials[this.round].trialNum + 1) !== 120)) {
            const perc = this.numTrials === 0 ? 100 : ((this.correct / this.numTrials) * 100).toFixed(0)
            // console.log('correct: ' + this.correct)
            // console.log('numTrials: ' + this.numTrials)
            const dialogRef = this.dialog.open(BreakDialog,
                {
                    data: {
                        feedback: true,
                        percentage: perc
                    }
                });

            dialogRef.afterClosed().subscribe(() => {
                setTimeout(() => {
                    this.doRound();
                }, this.delayBetweenRounds);
            });
        } else {
            setTimeout(() => {
                this.doRound();
            }, this.delayBetweenRounds);
        }
    }

    wait(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    async doRound() {
        this.roundFinished = false
        const delay = this.demo ? this.demoTrials[this.round].soa : this.trials[this.round].soa;
        let soundDelay: number;
        let blinkDelay: number;
        let auxdelay: number;
        if (delay < 0) { //SOUND FIRST!
            soundDelay = 0;
            blinkDelay = -delay;
            auxdelay = -(delay - 50)
            this.sound(true)
            await this.wait(blinkDelay)
            await this.blink(false)
            await this.wait(auxdelay)

        } else { //LIGHT FIRST
            // console.log("delay")
            // console.log(delay)
            soundDelay = delay;
            blinkDelay = 0;
            auxdelay = delay + 50
            await this.blink(true)
            await this.wait(soundDelay)
            this.sound(false)
            await this.wait(auxdelay)
        }
        this.roundFinished = true
    }


    openFullScreen() {
        // this.fullScreenService.open();
        this.isFullScreen = true
    }

    async startAfter() {
        this.startaf = true
        window.scrollTo(0, document.body.scrollHeight);
        await this.wait(1000)
        this.nextRound()
    }

    openInstructions = () => {
        this.dialog.open(InstructionsDialog)
    }



    save() {



        this.currentTrial.trialNumber = this.trials[this.round].trialNum
        this.currentTrial.intendedSOA = this.trials[this.round].soa;
        this.currentTrial.index = this.trials[this.round].index;

        this.currentTrial.actualSOA = this.currentTrial.beepTimeStamp - this.currentTrial.flashTimeStamp;

        console.log("------------------[ ROUND " + this.currentTrial.trialNumber + " ]-----------------")
        console.log("Sto salvando:")
        console.log("actual SOA: ", this.currentTrial.actualSOA)
        console.log("intended SOA: ", this.currentTrial.intendedSOA)
        console.log("beep Time Stamp: ", this.currentTrial.beepTimeStamp)
        console.log("flash Time Stamp: ", this.currentTrial.flashTimeStamp)
        console.log("response Time Stamp: ", this.currentTrial.responseTimeStamp)

        if (this.currentTrial.intendedSOA < 0) {
            console.log("diff resp and BEEP:", this.currentTrial.responseTimeStamp - this.currentTrial.beepTimeStamp)
            if (this.currentTrial.responseTimeStamp - this.currentTrial.beepTimeStamp < Math.abs(this.currentTrial.intendedSOA)) {
                this.currentTrial.flashTimeStamp = null;
                this.currentTrial.actualSOA = null;
            }
        }
        if (this.currentTrial.intendedSOA > 0) {
            console.log("diff resp and FLASH:", this.currentTrial.responseTimeStamp - this.currentTrial.flashTimeStamp)
            if (this.currentTrial.responseTimeStamp - this.currentTrial.flashTimeStamp < this.currentTrial.intendedSOA) {
                this.currentTrial.beepTimeStamp = null;
                this.currentTrial.actualSOA = null;
            }
        }
        console.log("---------------------------------------------")


        this.currentTrial.audioSource = this.audioSource

        this.tbwService.save(this.currentTrial).then(_resp => {

            if (this.trials[this.round].trialNum === 119) {

                const dialogRef = this.dialog.open(FeedbackCountDialog,
                    {
                        data: {
                            type: 'percentage',
                            percentage: ((this.correct / this.numTrials) * 100).toFixed(0),
                            demo: false
                        }
                    })


                dialogRef.afterClosed().subscribe(() => {
                    //finished
                    this.testFinished = true
                    this.started = false
                    setTimeout(() => {
                        this.router.navigate([''])
                    }, 3000)
                    this.tbwService.setDemo({ noReset: false, newVal: false })
                        .then(() => { return }) .then(() => {
                            this.taskService.saveCompletedTask({ "type": "FlashBeep" })
                          })
                })
            }
            else {
                this.round += 1;
                this.nextRound();
            }
        }).catch(e => {
            console.log(e);
        });

    }

    timestamp() {
        return new Date().getTime();
    }

    @HostListener('document:fullscreenchange', ['$event'])
    @HostListener('document:webkitfullscreenchange', ['$event'])
    @HostListener('document:mozfullscreenchange', ['$event'])
    @HostListener('document:MSFullscreenChange', ['$event'])
    didChangeFullScreen(event) {
        //console.log("ENTRE A ESTA MAGIA")
        //console.log(event)
        this.startaf = false
        this.isFullScreen = !!(document.fullscreenElement
            || document.webkitFullscreenElement
            || document.mozFullScreenElement);

    }
    pressKey(detail) {
        if (this.waitingResponse) {
            this.waitingResponse = false
            this.currentTrial.responseTimeStamp = this.timestamp();
            if (this.trials[this.round].soa === 400 || this.trials[this.round].soa === -400)
                this.numTrials++
            if (detail === "light") {
                this.currentTrial.respondedFlashFirst = true;
                //update correct count for feedback
                if (this.demo && this.demoTrials[this.round].soa > 0) {
                    //feedback for demo
                    this.correct++
                }
                else if (!this.demo && (this.trials[this.round].soa === 400)) {
                    //feedback for experiment ONLY for biggest soa
                    this.correct++
                    //this.numTrials++
                }


            } else if (detail === "sound") {
                this.currentTrial.respondedFlashFirst = false;

                if (this.demo && this.demoTrials[this.round].soa < 0) {
                    //feedback for demo
                    this.correct++
                }
                else if (!this.demo && this.trials[this.round].soa === -400) {
                    //feedback for experiment ONLY for biggest soa
                    this.correct++
                    //this.numTrials++
                }
            }
            if (!this.demo) {
                this.save();
            }
            else {
                //DEMO
                if ((this.round + 1) === 8) {
                    //END OF DEMO

                    //feedback for demo!
                    const dialogRef = this.dialog.open(FeedbackCountDialog,
                        {
                            data: {
                                type: 'percentage',
                                percentage: ((this.correct / 8) * 100).toFixed(0),
                                demo: true
                            }
                        })

                    dialogRef.afterClosed()
                        .subscribe(() => {
                            this.correct = 0
                            this.round = 0
                            this.demo = false
                            this.demoFinished = true
                            this.started = false
                            this.startaf = false
                            this.tbwService.setDemo({ noReset: false, newVal: true })
                        })

                }
                else {
                    this.round++
                    this.nextRound()
                }
            }
        }
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (!this.isFullScreen && !window.screenTop && !window.screenY) {
            this.isFullScreen = true

        }

        if (this.waitingResponse && this.startaf) {
            if (event.key === KEY_CODE.RIGHT_ARROW) {
                if (this.trials[this.round].soa === 400 || this.trials[this.round].soa === -400)
                    this.numTrials++
                //RIGHT --> FLASH FIRST
                this.waitingResponse = false
                this.currentTrial.responseTimeStamp = this.timestamp();
                this.currentTrial.respondedFlashFirst = true;

                //update correct count for feedback
                if (this.demo && this.demoTrials[this.round].soa > 0) {
                    //feedback for demo
                    this.correct++
                }
                else if (!this.demo && this.trials[this.round].soa === 400) {
                    //feedback for experiment ONLY for biggest soa
                    this.correct++
                    //this.numTrials++
                }



                if (!this.demo) {
                    this.save();
                }
                else {
                    if ((this.round + 1) === 8) {

                        //feedback for demo!
                        const dialogRef = this.dialog.open(FeedbackCountDialog,
                            {
                                data: {
                                    type: 'percentage',
                                    percentage: ((this.correct / 8) * 100).toFixed(0),
                                    demo: true
                                }
                            })
                        dialogRef.afterClosed()
                            .subscribe(() => {
                                this.currentTrial.flashTimeStamp = 0;
                                this.currentTrial.beepTimeStamp = 0;
                                this.correct = 0
                                this.round = 0
                                this.demo = false
                                this.demoFinished = true
                                this.started = false
                                this.startaf = false
                                localStorage.setItem('demoDone', 'true')
                            })

                    }
                    else {
                        this.round++
                        this.nextRound()
                    }
                }

            } else if (event.key === KEY_CODE.LEFT_ARROW) {
                //LEFT --> SOUND FIRST
                this.waitingResponse = false
                this.currentTrial.responseTimeStamp = this.timestamp();
                this.currentTrial.respondedFlashFirst = false;
                if (this.trials[this.round].soa === 400 || this.trials[this.round].soa === -400)
                    this.numTrials++

                if (this.demo && this.demoTrials[this.round].soa < 0) {
                    //feedback for demo
                    this.correct++
                }
                else if (!this.demo && this.trials[this.round].soa === -400) {
                    //feedback for experiment ONLY for biggest soa
                    this.correct++
                    //this.numTrials++
                }

                if (!this.demo) {
                    this.save();
                }
                else {

                    if ((this.round + 1) === 8) {

                        //feedback for demo!
                        const dialogRef = this.dialog.open(FeedbackCountDialog,
                            {
                                data: {
                                    type: 'percentage',
                                    percentage: ((this.correct / 8) * 100).toFixed(0),
                                    demo: true
                                }
                            })
                        dialogRef.afterClosed()
                            .subscribe(() => {
                                this.currentTrial.flashTimeStamp = 0;
                                this.currentTrial.beepTimeStamp = 0;
                                this.correct = 0
                                this.round = 0
                                this.demo = false
                                this.demoFinished = true
                                this.started = false
                                this.startaf = false
                                localStorage.setItem('demoDone', 'true')
                            })
                    }
                    else {
                        this.round++
                        this.nextRound()
                    }

                }
            } else if (this.started) {
                this.snackBar.open(this.msg1, '', {
                    duration: 3000,
                });
            }
        }

    }
}

export enum KEY_CODE {
    RIGHT_ARROW = 'ArrowRight',
    LEFT_ARROW = 'ArrowLeft'
}

class Trial {
    index;
    trialNumber;
    intendedSOA;
    actualSOA;
    flashTimeStamp;
    beepTimeStamp;
    responseTimeStamp;
    respondedFlashFirst;
    audioSource;
}
